.atm_vy_1osqo2v{width:100%;}
.atm_26_1x778eo{background:white;}
.atm_9s_1txwivl{display:flex;}
.atm_fc_h9n0ih.atm_fc_h9n0ih{justify-content:end;}
.atm_cx_ftgil2{gap:8px;}
.atm_l8_exct8b{padding:16px;}
.atm_l8_10029f0{padding:16px 0px;}
.atm_l8_zikty{padding:0px 16px;}
